<template>
    <div id="newsList">
        <ul>
            <router-link :to="{path:'news/cont',query:{id:item.id}}" tag="li" v-for="(item,i) in newCont" :key="i">
                <div class="listLeft">
                    <div>{{item.day}}</div>
                    <p>{{item.year}}</p>
                </div>
                <div class="listRight">
                    <div class="listCont">
                        <div >{{item.title}}</div>
                        <div>{{item.brief}}</div>
                    </div>
                    <div class="listLink">
                        <p>MORE</p>
                        <P><i class="el-icon-right"></i></P>
                    </div>
                </div>
            </router-link>
        </ul>
    </div>
</template>

<script>
import {data_test} from '@/assets/js/data.js'
// 引入data.js 文件
const newList = {
    data_test
}

export default {
    name: 'List2',
    data(){
        return{
            newCont:[], //文章列表
        }
    },
    mounted(){
        this.newCont = newList.data_test//把数组反转
    }
}
</script>

<style scoped>
    #newsList{
        background: #edf0f5;
    }
    #newsList>ul{
        padding: 0 20px 0 10px;
        width: 1090px;
        margin: 0 auto;
        background: #fff;
        padding-bottom: 15px;
    }
    #newsList>ul>li{
        border-bottom: 1px solid #ddd;
        padding: 30px 0 25px 0px;
        overflow: hidden;
        cursor: pointer;
    }
    #newsList>ul>li:hover .listLink,
    #newsList>ul>li:hover .listCont>div:first-child{
        color: #0069ce;
    }
    .listLeft{
        float: left;
        color: #afb0af;
    }
    .listLeft>div{
        font-size: 24px;
        font-weight: bold;
    }
    .listRight{
        float: left;
        margin-left: 30px;
        width: calc(100% - 100px);
    }
    .listCont{
        width: 665px;
        float: left;
    }
    .listCont>div:first-child{
        font-size: 15px;
        font-weight:bold;
        margin: 5px 0;
        overflow: hidden;               
        white-space: nowrap;         
        text-overflow: ellipsis;   
    }
    .listCont>div:last-child{
        color: #5b5b5b;
        overflow: hidden;               /*把超出的内容进行隐藏*/
        white-space: nowrap;          /*设置内容不换行*/
        text-overflow: ellipsis;   /*设置超出内容为省略号*/
    }
    .listLink{
        float: right;
        text-align: center;
    }
</style>
